import AltDateWidget from "./AltDateWidget";
import AltDateTimeWidget from "./AltDateTimeWidget";
import CheckboxWidget from "./CheckboxWidget";
import CheckboxesWidget from "./CheckboxesWidget";
import ColorWidget from "./ColorWidget";
import DateWidget from "./DateWidget";
import DateTimeWidget from "./DateTimeWidget";
import EmailWidget from "./EmailWidget";
import FileWidget from "./FileWidget";
import HiddenWidget from "./HiddenWidget";
import PasswordWidget from "./PasswordWidget";
import RadioWidget from "./RadioWidget";
import RangeWidget from "./RangeWidget";
import SelectWidget from "./SelectWidget";
import TextareaWidget from "./TextareaWidget";
import TextWidget from "./TextWidget";
import TimeWidget from "./TimeWidget";
import URLWidget from "./URLWidget";
import UpDownWidget from "./UpDownWidget";

function widgets() {
  return {
    AltDateWidget: AltDateWidget,
    AltDateTimeWidget: AltDateTimeWidget,
    CheckboxWidget: CheckboxWidget,
    CheckboxesWidget: CheckboxesWidget,
    ColorWidget: ColorWidget,
    DateWidget: DateWidget,
    DateTimeWidget: DateTimeWidget,
    EmailWidget: EmailWidget,
    FileWidget: FileWidget,
    HiddenWidget: HiddenWidget,
    PasswordWidget: PasswordWidget,
    RadioWidget: RadioWidget,
    RangeWidget: RangeWidget,
    SelectWidget: SelectWidget,
    TextWidget: TextWidget,
    TextareaWidget: TextareaWidget,
    TimeWidget: TimeWidget,
    UpDownWidget: UpDownWidget,
    URLWidget: URLWidget
  };
}

export default widgets;